export const ESIGN_MODAL = 'ESIGN_MODAL';
export const ESIGN_CAN_WITHDRAW = 'ESIGN_CAN_WITHDRAW';
export const ESIGN_DATA = 'ESIGN_DATA';

export const setEsignModal = (status) => (dispatch) => {
    dispatch({ type: ESIGN_MODAL, status });
};

export const setEsignCanWithdraw = (status) => (dispatch) => {
    dispatch({ type: ESIGN_CAN_WITHDRAW, status });
};

export const setEsignData = (data) => (dispatch) => {
    dispatch({ type: ESIGN_DATA, data });
};

export default {
    ESIGN_MODAL,
    ESIGN_CAN_WITHDRAW,
    ESIGN_DATA,
    setEsignModal,
    setEsignCanWithdraw,
    setEsignData,
};
